"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlarmFromAlarmCode = exports.AlarmTagFromAlarmCode = exports.alarmCodeTagMap = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../../schema");
const hydrotap_bridge_1 = require("../../../device/class/hydrotap-bridge");
exports.NAMESPACE = 'Culligan.Protocol.Common.Device.HydroTapBridge';
exports.alarmCodeTagMap = [
    [0, 'powerBoardFault'],
    [1, 'interfaceFault'],
    [4, 'waterLeak'],
    [5, 'compressorOverRun'],
    [6, 'waterSupplyFailure'],
    [7, 'hotSensorOpen'],
    [8, 'hotSensorClosed'],
    [9, 'coldSensorOpen'],
    [10, 'coldSensorClosed'],
    [11, 'floodSensorOpen'],
    [12, 'condenserSensorClosed'],
    [13, 'condenserSensorOpen'],
    [14, 'heaterFuseFault'],
    [15, 'heaterDriverFault'],
    [16, 'compressorDriverFault'],
    [17, 'hotSensorDegraded'],
    [18, 'condenserOvertemp'],
    [19, 'pumpFaulty'],
    [20, 'steamTooCool'],
    [21, 'steamSensorOpen'],
    [22, 'steamSensorClosed'],
    [23, 'overSteamed'],
    [24, 'hotTankOverfilled'],
    [25, 'compressorFuse'],
    [27, 'boilDryProtection'],
    [30, 'hotTankTimeout'],
    [31, 'coldTankTimeout'],
    [53, 'uvNotPresent'],
    [54, 'uvOverTemp'],
    [55, 'uvUnderCurrent'],
    [56, 'uvOverCurrent'],
    [57, 'uvCommsError'],
];
exports.AlarmTagFromAlarmCode = effect_1.Schema.transformLiterals(...exports.alarmCodeTagMap).annotations({
    identifier: `${exports.NAMESPACE}.AlarmTagFromAlarmCode`,
    documentation: 'https://culligan.atlassian.net/browse/IOTPE-355',
});
exports.AlarmFromAlarmCode = exports.AlarmTagFromAlarmCode.pipe((0, schema_1.Singleton)('_tag'), effect_1.Schema.compose(effect_1.Schema.Union(...hydrotap_bridge_1.HydroTapBridge.alarms.firmwareBased))).annotations({ identifier: `${exports.NAMESPACE}.AlarmFromAlarmCode` });
//# sourceMappingURL=hydrotap-bridge.js.map